export function getUserPreferences() {
  const prefersDarkMode = window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;

  return {
    prefersDarkMode,
  };
}
